import { Breakpoint, Container, Paper } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

export const AuthContainer: FC<PropsWithChildren<{maxWidth?: Breakpoint}>> = ({children, maxWidth = "sm"}) => <Container maxWidth={maxWidth}>
    <Paper elevation={3} sx={{
        maxWidth: 600,
        my: 8,
        mx: "auto",
        p: 4
    }}>
    {children}
    </Paper>
</Container>